import React, { useEffect, useState, useRef } from "react";
import "../AlertMessage/toast.css";

const VARIANTS = {
  delete: {
    image:
      "https://uat-atomicdesign.rrd.com/ITProjects/HCM/img/svg/alert-delete.svg",
    bg: "#FFF6F6",
    border: "#FFCCCC",
    titleColor: "#CE0016",
    messageColor: "#CE0016",
    closeColor: "#CE0016",
  },
  success: {
    image:
      "https://uat-atomicdesign.rrd.com/ITProjects/HCM/img/svg/alert-success.svg",
    bg: "#EFFFF3",
    border: "rgba(17, 94, 89, 0.19)",
    titleColor: "#00761A",
    messageColor: "#00761A",
    closeColor: "#115E59",
  },
  mandatory: {
    image:
      "https://uat-atomicdesign.rrd.com/ITProjects/HCM/img/svg/alert-mandatory.svg",
    bg: "#F3F6FF",
    border: "#BECEFF",
    titleColor: "#0208A4",
    messageColor: "#0208A4",
    closeColor: "#1E40AF",
  },
  info: {
    image:
      "https://uat-atomicdesign.rrd.com/ITProjects/HCM/img/svg/alert-info.svg",
    bg: "#FFF9F3",
    border: "#FEE3CA",
    titleColor: "#BE7600",
    messageColor: "#BE7600",
    closeColor: "#C36002",
  },
};

const Toast = ({ id, type, title, message, removeToast }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const selected = VARIANTS[type];

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => removeToast(id), 3000);
    }, 3000);

    return () => clearTimeout(timer);
  }, [id, removeToast]);

  const contentRef = useRef(null);
  const [isSingleLine, setIsSingleLine] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.offsetHeight;

      if (height < 30) {
        setIsSingleLine(true);
      } else {
        setIsSingleLine(false);
      }
    }
  }, [title, message]);

  return (
    <div
      className={`toast ${fadeOut ? "fade-out" : ""} ${isSingleLine ? "single-line" : ""}`}
      style={{
        backgroundColor: selected.bg,
        border: `0.5px solid ${selected.border}`,
      }}
    >
      <div className="toast-image">
        <img src={selected.image} alt="icon" />
      </div>
      <div ref={contentRef} className="toast-content">
        {title && <h4 style={{ color: selected.titleColor }}>{title}</h4>}
        {message && <p style={{ color: selected.messageColor }}>{message}</p>}
      </div>

      <div>
        <button
          type="button"
          className="toast-close"
          style={{ color: selected.closeColor }}
          onClick={() => {
            setFadeOut(true);
            setTimeout(() => removeToast(id), 100);
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default Toast;
